import { render, staticRenderFns } from "./testimonial-item.vue?vue&type=template&id=e79bce22&scoped=true&"
import script from "./testimonial-item.vue?vue&type=script&lang=js&"
export * from "./testimonial-item.vue?vue&type=script&lang=js&"
import style0 from "./testimonial-item.vue?vue&type=style&index=0&id=e79bce22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e79bce22",
  null
  
)

export default component.exports